// extracted by mini-css-extract-plugin
export default {"unknown_product":"unknownProduct_unknown_product__GyP58"};